import React from "react";

const getTableContent = (
  tableRef: React.RefObject<HTMLDivElement | null>,
  operationType: string
) => {
  if (tableRef && tableRef.current) {
    const table = tableRef.current.querySelector("table");
    if (!table) return;

    const rows = table.querySelectorAll("tr");
    const tableContent = Array.from(rows)
      .map((row) => {
        const cells = row.querySelectorAll("th, td");
        return Array.from(cells)
          .map((cell) => `"${cell.textContent?.trim()}"` || "")
          .join(operationType === "copy" ? "\t" : ",");
      })
      .join("\n");

    return tableContent;
  }
  return "";
};

export const copyTable = async (
  tableRef: React.RefObject<HTMLDivElement | null>
) => {
  try {
    const tableContent = getTableContent(tableRef, "copy");

    if (!tableContent || typeof tableContent !== "string") {
      console.warn("not valid content.");
      return false;
    }

    await navigator.clipboard.writeText(tableContent);
    return true;
  } catch (e) {
    console.log("error while copying the table content");
    return false;
  }
};

export const downloadTable = (
  tableRef: React.RefObject<HTMLDivElement | null>,
  downloadRef: React.RefObject<HTMLAnchorElement | null>
) => {
  const tableContent = getTableContent(tableRef, "copy");

  if (!tableContent || typeof tableContent !== "string") {
    return;
  }

  const csvBlob = new Blob([tableContent], { type: "text/csv" });
  const url = URL.createObjectURL(csvBlob);
  if (downloadRef.current) {
    downloadRef.current.href = url;
    downloadRef.current.download = "data.csv";
    downloadRef.current.click();
    setTimeout(() => URL.revokeObjectURL(url), 100);
  }
};
